import { ReactElement } from "react";
import { H4, InputField, InputPercentage } from "@sellar-io/components";
import { generateFormPath } from "~/utils/formHelpers";
import { BusinessFormApi } from "../business/BusinessFormValues";
import {
  fieldNote,
  getFieldError,
  invalidFieldClassName,
  numberRequiredField,
} from "../business/formValidation";
import { fieldName } from "./SupplierFormFragment.shared";

export type SupplierFieldValues = {
  urlId: string;
  transactionFee: number;
  vatPercentage: number | "";
  stripeAccountId: string;
  stripeCustomerId: string;
  imageUrl: string;
};

export function SupplierFormFragment({
  form,
  path,
}: {
  form: BusinessFormApi;
  path?: string;
}): ReactElement {
  return (
    <section className="flex flex-col gap-4 border-t border-solid border-zinc-200 pt-5">
      <H4 className="text-zinc-900 dark:text-zinc-100">Supplier settings</H4>
      <div className="grid gap-4 md:grid-cols-2">
        <NumberField
          form={form}
          name={generateFormPath("vatPercentage", path)}
          label="VAT Percentage"
        />
      </div>
    </section>
  );
}

const NumberField = ({
  form,
  name,
  label,
}: {
  form: BusinessFormApi;
  name: string;
  label: string;
}) => (
  <form.Field name={fieldName(name)} validators={numberRequiredField(label)}>
    {({ state, handleChange, handleBlur }) => {
      const errorMessage = getFieldError(state.meta.errors);

      return (
        <InputField
          label={label}
          className={errorMessage ? invalidFieldClassName : undefined}
          note={fieldNote(undefined, errorMessage)}
          containerClassName={
            errorMessage
              ? "border-red-300 focus-within:border-red-500"
              : undefined
          }
        >
          <InputPercentage
            name={name}
            value={typeof state.value === "number" ? state.value : ""}
            min={0}
            max={100}
            onBlur={handleBlur}
            onChange={(event) => {
              const value = event.target.valueAsNumber;
              handleChange(Number.isNaN(value) ? "" : value);
            }}
            required
          />
        </InputField>
      );
    }}
  </form.Field>
);
